module.exports = {};



//////////////////
// WEBPACK FOOTER
// c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/node_modules/core-js/modules/_iterators.js
// module id = 48
// module chunks = 0